function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M13.9930919,13.1181638 C13.9976539,13.0794106 14,13.0399793 14,13 L14,3 C14,2.44771525 13.5522847,2 13,2 L3,2 C2.9598178,2 2.92018914,2.00236997 2.88124617,2.00697776 C3.10304597,1.41855726 3.67129908,1 4.33731147,1 L13.4444444,1 C14.3035541,1 15,1.69644594 15,2.55555556 L15,11.6621247 C15,12.3281109 14.5814758,12.8963454 13.9930919,13.1181638 Z M2,3 L12,3 C12.5522847,3 13,3.44771525 13,4 L13,14 C13,14.5522847 12.5522847,15 12,15 L2,15 C1.44771525,15 1,14.5522847 1,14 L1,4 C1,3.44771525 1.44771525,3 2,3 Z M2,4 L2,14 L12,14 L12,4 L2,4 Z M2,14 L5,9 L7,11 L10,7 L12,10 L12,14 L2,14 Z M4.5,8 C3.67157288,8 3,7.32842712 3,6.5 C3,5.67157288 3.67157288,5 4.5,5 C5.32842712,5 6,5.67157288 6,6.5 C6,7.32842712 5.32842712,8 4.5,8 Z"
});

var SvgGallery = function SvgGallery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGallery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Gallery.8c0043df.svg";
export { ForwardRef as ReactComponent };